var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3629 8.09321C25.6636 9.46063 27.3139 10.1443 27.8186 11.1067C28.2762 11.9792 28.2762 13.0208 27.8186 13.8933C27.3139 14.8557 25.6636 15.5394 22.3629 16.9068L8.48804 22.655C5.22732 24.0058 3.59696 24.6813 2.56341 24.3623C1.62616 24.0731 0.889499 23.344 0.590655 22.4097C0.261107 21.3795 0.919749 19.7423 2.23704 16.4679L3.83333 12.4999L2.2371 8.53216C0.919792 5.25773 0.261139 3.62052 0.590687 2.59029C0.88953 1.65607 1.62619 0.92693 2.56344 0.637702C3.59699 0.318753 5.22736 0.99419 8.48808 2.34506L22.3629 8.09321Z",
    fill: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.639cf6d842816c01335a3b72a3fc39a6.svg";
export { ForwardRef as ReactComponent };